// @flow
import { createSelector } from 'reselect';
import { eventSelector } from '../event/event.selectors.js';
import { getOption, type Option } from '../form/select.js';

export const organizationsSelector = createSelector(
  state => state.organizations,
  (
    organizations: $ElementType<ReduxState, 'organizations'>
  ): $ElementType<ReduxState, 'organizations'> => organizations
);

export const organizationsListSelector = createSelector(
  organizationsSelector,
  (organizations): List => Object.keys(organizations)
);

export const organizationSelector = createSelector(
  (state: ReduxState) => state.organization,
  (
    organization: $ElementType<ReduxState, 'organization'>
  ): $ElementType<ReduxState, 'organization'> => organization
);

export const organizationByEventSelector = createSelector(
  organizationsSelector,
  eventSelector,
  (
    organizations: $ElementType<ReduxState, 'organizations'>,
    event
  ): $ElementType<ReduxState, 'organization'> => organizations[event.organizationID] || {}
);

export const organizationsOptionsSelector = createSelector(
  organizationsSelector,
  organizationsListSelector,
  (organizations: $ElementType<ReduxState, 'organizations'>, list: List): Option[] =>
    [getOption('All Unpaid Invoices', 'all')].concat(
      list.reduce((acc, id) => acc.concat(getOption(organizations[id].name, id)), [])
    )
);
